import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';


        
const consent = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.ArialBlack]}>Consent Form</Text>
                 <Text style={[style.subtitle]}>( Amount to be indicated should be as per indicated in form No 1 of Gratuity Proposal )</Text>

                <View style={style.solidLine} />
               
                <Text style={[style.paragraph, { marginTop: 20, lineHeight: 2 }]}>
              I , {result.employeeName} , {result.designation} hereby give consent for the recovery of the amount Rs... 0/- In words Rs NIL... from my gratuity . Reason for recovery on account of ......................... NIL....................
                </Text>
                      
           
                      
           
                <Text style={[style.signature, {marginTop: 20}]}>{result.employeeName}</Text>

              <Text style={[style.paragraph, { marginTop: 20}]}>
                Countersigned by :
              </Text>
              <Text style={[style.paragraph]}>
                Edu. Officer , {result.educationOfficer}
              </Text>
           </View>

);

export default consent;